import React, { useState, useEffect } from "react";


import { collection, doc, setDoc, onSnapshot  } from "firebase/firestore"; 
import { database } from "../firebaseConfig2";


function SpotifyPlayer() {
    const [isSOTW, setIsSOTW] = useState(true);

    const [status, setStatus] = useState({
           date: 'Loading...',
            src: 'Loading...',
            title: 'Loading...',
            artist: 'Loading...',
            comment: 'Loading...'
        });

        const [statusList, setStatusList] = useState([]);

     useEffect(
        () =>
          onSnapshot(collection(database, "SOTW"), (snapshot) => {
            snapshot.forEach((doc) => {
              let tempstatus = {
                date: doc.data().date,
                src: `${doc.data().src}&color=%23b45b55&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true`,
                title: doc.data().title,
                artist: doc.data().artist,
                comment: doc.data().comment
              }
              setStatusList(statusList.push(tempstatus));
            });
            setStatus(statusList.at(-1));
          }),
        []
      );

    return (
     <div className="status-wrapper" id="soundcloud-wrapper"> 
     {/* LMFAOOOOO */}
        <div className="status-title">
            <p>⊹ Song of the Week</p>
            <p> {status.date}  </p>
          </div>
        
        <div className="soundcloud-widget">
       <div className="color-overlay"></div>
        <iframe width="100%" height="200" scrolling="no" frameBorder="no" allow="autoplay; encrypted-media" 
        src={status.src}>
        </iframe>

        </div>
       
        <div className="song-title">
            <h3>{status.title}</h3>
            <p style={{ fontStyle: "italic" }}> ── {status.artist}</p>
        </div>
        <div className="scroller">
            <div className = "first">
              <p>
                {status.comment}
              </p>
            </div>
        </div>
    </div>
    );
  }

  export default SpotifyPlayer;